<!-- add College Batch popup -->
<div class="addcollegebatch-popup modalpopup-wrap common-popup-ui" *ngIf="this.flag">
  <div class="modal-header">
    <h5 class="modal-title" *ngIf="this.collegeBatchId == 0">{{CollegeBatchConstant.AddCollegeBatch }}</h5>
    <h5 class="modal-title" *ngIf="this.collegeBatchId > 0">{{CollegeBatchConstant.EditCollegeBatch }}</h5>
    <button type="button" class="btn-close" aria-label="Close" (click)="modalService.dismiss()">
      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
        <circle cx="12" cy="12" r="12" fill="#F85D5D" />
        <path
          d="M16.4978 8.32578C16.3954 8.22255 16.2736 8.14062 16.1394 8.0847C16.0051 8.02879 15.8612 8 15.7158 8C15.5704 8 15.4265 8.02879 15.2922 8.0847C15.158 8.14062 15.0362 8.22255 14.9338 8.32578L12.4118 10.8589L9.88969 8.32578C9.6823 8.11839 9.40102 8.00188 9.10773 8.00188C8.81444 8.00188 8.53316 8.11839 8.32578 8.32578C8.11839 8.53316 8.00188 8.81444 8.00188 9.10773C8.00188 9.40102 8.11839 9.6823 8.32578 9.88969L10.8589 12.4118L8.32578 14.9338C8.22255 15.0362 8.14062 15.158 8.0847 15.2922C8.02879 15.4265 8 15.5704 8 15.7158C8 15.8612 8.02879 16.0051 8.0847 16.1394C8.14062 16.2736 8.22255 16.3954 8.32578 16.4978C8.42816 16.601 8.54997 16.6829 8.68418 16.7388C8.81839 16.7947 8.96234 16.8235 9.10773 16.8235C9.25312 16.8235 9.39707 16.7947 9.53128 16.7388C9.66549 16.6829 9.7873 16.601 9.88969 16.4978L12.4118 13.9647L14.9338 16.4978C15.0362 16.601 15.158 16.6829 15.2922 16.7388C15.4265 16.7947 15.5704 16.8235 15.7158 16.8235C15.8612 16.8235 16.0051 16.7947 16.1394 16.7388C16.2736 16.6829 16.3954 16.601 16.4978 16.4978C16.601 16.3954 16.6829 16.2736 16.7388 16.1394C16.7947 16.0051 16.8235 15.8612 16.8235 15.7158C16.8235 15.5704 16.7947 15.4265 16.7388 15.2922C16.6829 15.158 16.601 15.0362 16.4978 14.9338L13.9647 12.4118L16.4978 9.88969C16.601 9.7873 16.6829 9.66549 16.7388 9.53128C16.7947 9.39707 16.8235 9.25312 16.8235 9.10773C16.8235 8.96234 16.7947 8.81839 16.7388 8.68418C16.6829 8.54997 16.601 8.42816 16.4978 8.32578Z"
          fill="#F4F4F4" />
      </svg>
    </button>
  </div>
  <div class="modal-body m-0">
    <form [formGroup]="CollegeBatchForm" (ngSubmit)="saveCollageBatch()" #collegeBatchForm="ngForm" novalidate>
      <div class="row">
        <div class="col-md-12 col-12">
          <div class="form-group mb-4 matselectfield">
            <label>{{CollegeBatchConstant.CollegeName }}<span class="form-control-danger">*</span> </label>
            <mat-form-field>
              <mat-select class="form-control" id="style" formControlName="CollegeId" [attr.disabled]="true"
                placeholder="Select College" #singleSelect>
                <mat-option>
                  <ngx-mat-select-search placeholderLabel="Search College..."
                    noEntriesFoundLabel="'no matching college found'"
                    [formControl]="FilterCtrl"></ngx-mat-select-search>
                </mat-option>
                <mat-option *ngFor="let colleges of filteredData | async" [value]="colleges.id">
                  {{colleges.value}}
                </mat-option>
              </mat-select>
            </mat-form-field>
            <span class="text-danger" *ngIf="isCollegeSelected">{{errorMessage.CollegeNameIsRequired}}</span>
          </div>
        </div>
        <div class="col-md-12 col-12">
          <div class="form-group mb-4">
            <label> {{CollegeBatchConstant.BatchName }}<span class="form-control-danger">*</span></label>
            <input type="text" class="form-control
                    form-control-lg" required autocomplete="off" formControlName="BatchName"
              placeholder="Enter Batch Name"
              [ngClass]="{'form-control-danger': collegeBatchForm.submitted && collegeBatchFormControl['BatchName'].errors?.['required']}"
              oninput="this.value = this.value.replace(/^\s+/g, '')" maxlength="100">
            <span class="text-danger"
              *ngIf="collegeBatchForm.submitted && collegeBatchFormControl['BatchName'].errors?.['required']">
              {{errorMessage.BatchIsRequired}}
            </span>
            <span class="text-danger" *ngIf=" collegeBatchFormControl['BatchName'].errors?.['maxlength']">
              {{CollegeBatchConstant.COLLEGE_BATCH_NAME_LENGTH}}
            </span>
          </div>
        </div>
        <div class="col-md-12 col-12">
          <div class="form-group mb-4">
            <label>{{CollegeBatchConstant.BatchYear}}<span class="form-control-danger">*</span></label>
            <input type="number" class="form-control
                    form-control-lg" required autocomplete="off" formControlName="BatchYear"
              placeholder="Enter Batch Year"
              [ngClass]="{'form-control-danger': collegeBatchForm.submitted && collegeBatchFormControl['BatchYear'].errors?.['required']}"
              maxlength="4"
              oninput="this.value = this.value.replace(/[e.-]/gi, ''); this.value = this.value.replace(/^0+/, '');">
            <span class="text-danger"
              *ngIf="collegeBatchForm.submitted && collegeBatchFormControl['BatchYear'].errors?.['required']">
              {{errorMessage.BatchYearIsRequired}}
            </span>
            <span class="text-danger" *ngIf="collegeBatchFormControl['BatchYear'].errors?.['pattern']">
              {{errorMessage.BatchYearRange}}
            </span>
          </div>
        </div>
        <div class="col-sm-12">
          <div class="modal-footer justify-content-between border-0 px-2 py-0 mt-3">
            <button *ngIf="this.collegeBatchId == 0" type="submit" class="btn btn-primary common-button"
              id="btn-save">{{CommonConstant.SAVE}}</button>
            <button *ngIf="this.collegeBatchId > 0" type="submit" class="btn btn-primary common-button"
              id="btn-save">{{CommonConstant.UPDATE}}</button>
            <button type="button" class="btn btn-border common-button" data-bs-dismiss="modal"
              (click)="onCancel()">{{CommonConstant.CANCEL}}</button>
          </div>
        </div>
      </div>
    </form>
  </div>
</div>